<template>
  <div class="our aboutUs">
     <p class="our_common_title">留言</p>
     
     <div class="leavemsg_from">
       <div class="form_item">
          <label for='name'>姓名：</label><input type="text" name="" id='name' v-model='name'>
       </div>
       <div class="form_item">
          <label for='mobile'>电话：</label><input type="text" name="" id='mobile' v-model='mobile'>
       </div>
       <div class="form_item">
          <label for='email'>邮箱：</label><input type="text" name="" id='email' v-model='email'>
       </div>
       <div class="form_item sp">
          <label for='t'>留言：</label><textarea type="text" name="" id='t' v-model='content'></textarea>
       </div>
       <div class="submit" @click='submit' v-show='show'>提&emsp;交</div>
       <div class="submit" v-show='!show'>提&emsp;交</div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      name:'',
      mobile:'',
      email:'',
      content:'',
      show:true
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  },
  methods:{
    submit(){
      if(!this.name){
        alertMessage('请填写姓名');
        return false;
      }
      if(!/^1[34578]\d{9}$/.test(this.mobile)){
        alertMessage('请填写电话');
        return false;
      }
      if(!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(this.email)){
        alertMessage('请填写邮箱');
        return false;
      }
      if(!this.content){
        alertMessage('请填写留言');
        return false;
      }
      this.show=false
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=comment', this.$qs.stringify({
          username:this.name,
          tel:this.mobile,
          email:this.email,
          content:this.content
        }))
        .then(response => {
          console.log(response);
          alertMessage(response.data.info)
          this.show=true
        })
        .catch(error => {
          console.log(error);
          this.show=true
        });

    }
  }
}
</script>
<style scoped>
.aboutUs{

}
.banner{
  width: 100%;
  display: block;
}
.our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.5rem;
}
.leavemsg_from{
  padding: 0 0.2rem;
}
.form_item label,.form_item input{
  font-size: 0.24rem;
  color: #828282;
  vertical-align: middle;
}
.form_item{
  border:0.02rem solid #e4e4e4;
  box-sizing: border-box;
  padding: 0.3rem 0;
  padding-left: 0.28rem;
  margin-bottom: 0.26rem;
}
 .form_item input,.form_item textarea{
  width: 4.9rem;
 }
 .form_item.sp label{
  vertical-align: top;
 }
 .form_item.sp textarea{
  vertical-align: text-top;
  border:none;
  height: 3rem;
 }
 .submit{
  font-size: 0.36rem;
  color: #fff;
  text-align: center;
  height: 0.98rem;
  line-height: 0.98rem;
  background-color: #3478f7;
  border-radius: 0.04rem;
  margin-top: 0.54rem;
 }
</style>


// WEBPACK FOOTER //
// src/components/mobile/leavemsg.vue